<template>
  <div class="yunfei">
    <div class="padd_left">
      <p class="chongqi">
        <span>模板名称：</span>
        <el-input
          type="text"
          placeholder="填写模板名称"
          id="mbmc"
          v-model="name"
          class="muban_name yuanjiao"
        />
        <!-- <input type="checkbox" class="zhichi_input" v-model="status" @click="deldata()">
        <span>不支持全国配送</span>-->
        <el-checkbox v-model="status" @click="deldata">不支持全国配送</el-checkbox>
      </p>
      <p class="chongqi xiaozi" v-if="status==false">
        <span>默认运费：</span>
        <el-input type="text" placeholder="首件" v-model="formData.start_num" class="small-input"/>
        <span>件内，</span>
        <el-input type="text" placeholder="首费" v-model="formData.start_money" class="small-input"/>
        <span>元，每增加</span>
        <el-input type="text" placeholder="续件" v-model="formData.plus_num" class="small-input"/>
        <span>件，增加运费</span>
        <el-input type="text" placeholder="续费" v-model="formData.plus_money" class="small-input"/>
        <span>元</span>
      </p>
      <p v-if="status==true" class="shezhi yuanjiao pointer" @click="addData">为指定地区设置运费</p>
      <section style="margin-top:30px;">
        <table class="table table-hover table-bordered" v-if="status==true">
          <tr v-for="(items,index) in obj" :key="index">
            <td>
              <p>运送到</p>
              <button @click="hideFormchengshi(index)" class="addres">{{items.city_name}}</button>
            </td>
            <td>
              <p>首件（件）</p>
              <el-input class="small-input marginTop10" type="text" v-model="items.start_num"/>
            </td>
            <td>
              <p>首费（元）</p>
              <el-input class="small-input marginTop10" type="text" v-model="items.start_money"/>
            </td>
            <td>
              <p>续件（件）</p>
              <el-input class="small-input marginTop10" type="text" v-model="items.plus_num"/>
            </td>
            <td>
              <p>续费（元）</p>
              <el-input class="small-input marginTop10" type="text" v-model="items.plus_money"/>
            </td>
            <td>
              <p>操作</p>
              <span class="remove" @click="deleteconfig(index)">
                <img src="/static/img/guanbi.png">
              </span>
            </td>
          </tr>
        </table>
      </section>
      <p class="sub_btn">
        <el-button class="btn" @click="formsub">保存</el-button>
        <el-button class="btn" @click="YunFeiList">取消</el-button>
      </p>
    </div>
    <el-dialog
      title="选择城市"
      :visible.sync="xuanzechengshi"
      :before-close="hideFormchengshi"
      width="800px"
      :append-to-body="true"
    >
      <!-- 点击市的时候在这里添加按钮 -->
      <span>
        <table style="margin-top:1%;">
          <el-row style="float:left;" v-for="(item,index) in addshi" :key="index">
            <td>
              <el-button @click="unsershi(index);" type="primary" size="mini" round>{{item.value}}</el-button>
            </td>
          </el-row>
        </table>
      </span>
      <p style="margin-top:3%;">
        <b>全部省份</b>
      </p>
      <table style="margin-top:3%;width:679px;">
        <span
          v-for="item in province"
          :key="item.id"
          :label="item.value"
          :value="item.id"
          type="text"
        >
          <td style="width:50px;height:30px;margin-left:-10px;color:#409EFF;">
            <el-button size="small" @click="choseProvince(item.id)">{{item.value}}</el-button>
          </td>
        </span>
      </table>

      <p style="margin-top:3%;">
        <b>全部市</b>
      </p>

      <table style="margin-top:3%;">
        <span
          v-for="item in shi1"
          :key="item.id"
          :label="item.value"
          :value="item.id"
          @click="choseshi(item)"
          type="text"
        >
          <td style="width:50px;height:30px;margin-left:-10px;color:#409EFF;">
            <el-button size="small">{{item.value}}</el-button>
          </td>
        </span>
      </table>

      <el-button type="primary" @click="quedingcurrcity()">确定</el-button>
    </el-dialog>
  </div>
</template>
<script>
import { getYunList, Yundel, addYunFei, getdata } from "../api/freight/freight";

export default {
  name:'YunFei',
  data() {
    return {
      status: false,
      formData: [
        {
          start_num: "",
          start_money: "",
          plus_num: "",
          plus_money: "",
          // status: false,
          default: "1",
          city_id: "",
          city_name: ""
        }
      ],
      xuanzechengshi: false,
      //    provinceStap:"",
      addshi: [
        {
          id: "52",
          value: "北京"
        }
      ],
      current_city_index: "",
      formDatas: [
        {
          start_num: "",
          start_money: "",
          plus_num: "",
          plus_money: "",
          default: 0
        }
      ],
      obj: [
        {
          city_id: "52",
          city_name: "北京",
          start_num: "",
          start_money: "",
          plus_num: "",
          plus_money: ""
          // default: "1",
          // status: true
        }
      ],
      province: "",
      shi1: "",
      datas: {},
      name: ""
    };
  },
  methods: {
    deldata() {
      if (this.status == false) {
        this.obj = [{}];
        // this.formData = [{
        //   start_num: "",
        //   start_money: "",
        //   plus_num: "",
        //   plus_money: "",
        //   status: false,
        //   default: "1",
        //   city_id: "",
        //   city_name: ""
        // }];
      } else {
        this.formData = [
          {
            start_num: "",
            start_money: "",
            plus_num: "",
            plus_money: "",
            city_id: "",
            city_name: ""
          }
        ];
      }
      this.status = !this.status;
      // this.formData.status = !this.formData.status
    },
    addData() {
      if (this.status === true) {
        var arr = {};
        arr.city_id = "52";
        arr.city_name = "北京";
        arr.start_num = "";
        arr.start_money = "";
        arr.plus_num = "";
        arr.plus_money = "";
        // arr.default = "2";
        // arr.status = true;
        this.obj.push(arr);
      } else {
        var num = this.obj.length;
        this.obj.splice(0, num);
      }
    },
    addDatatrue() {
      if (this.status === true) {
        this.formDatas.default = 1;
        var num = this.obj.length;
        this.obj.splice(0, num);
      } else {
        this.formDatas.name = this.formData.name;
        this.formDatas.default = 0;
        this.obj.push(this.formDatas);
      }
    },
    deleteconfig(index) {
      var r = confirm("确定删除此规格？");
      if (r) {
        this.obj.splice(index, 1);
      } else {
        return;
      }
    },
    formsub() {
      if (this.status === true) {
        this.formData = this.obj;
      } else {
        this.formData[0].start_num = this.formData.start_num;
        this.formData[0].start_money = this.formData.start_money;
        this.formData[0].plus_num = this.formData.plus_num;
        this.formData[0].plus_money = this.formData.plus_money;
        this.formData[0].city_id = 52;
        this.formData[0].city_name = "北京";
      }
      var name = document.getElementById("mbmc").value;
      var uid = this.$cookies.get("uid");
      var token = this.$cookies.get("browser_token");
      for (var i = 0; i < this.formData.length; i++) {
        if (
          (typeof this.formData[i] == "string" && this.formData[i] == "") ||
          !this.formData[i]
        ) {
          this.$message.warning("请填写完整");
          return;
        }
        if (typeof this.formData[i] != "string") {
          for (var key in this.formData[i]) {
            if (this.formData[i][key] == "" || !this.formData[i][key]) {
              this.$message.warning("请填写完整");
              return;
            }
          }
        }
      }
      this.$emit("showYun", true);
      addYunFei(this.formData, name, uid, token)
        .then(response => {
          this.loading = false;
          // this.YunList = response.data.data.data || [];
          this.resetData();
          this.YunFeiList();
        })
        .catch(err => {
          console.error(err)
          this.loading = false;
          // this.YunList = [];
        });
    },
    YunFeiList() {
      // this.$router.push({ path: "/yunFeiList" });
      this.resetData();
      this.$emit("showYun", true);
    },
    //隐藏选择城市
    hideFormchengshi(index) {
      this.xuanzechengshi = !this.xuanzechengshi;
      this.current_city_index = index;
    },
    //加载省市信息
    getCityMessage() {
      var that = this;
      getdata()
        .then(function(response) {
          if (response) {
            var data = response.data;
            that.province = [];
            that.city = [];
            that.block = [];
            for (var item in data) {
              if (
                data[item].region_type == 1 ||
                data[item].region_type == "1"
              ) {
                //省

                that.province.push({
                  id: data[item].city_id,
                  parent_id: data[item].parent_id,
                  value: data[item].city_name,
                  children: []
                });
              } else if (
                data[item].region_type == 2 ||
                data[item].region_type == "2"
              ) {
                //市
                that.city.push({
                  id: data[item].city_id,
                  parent_id: data[item].parent_id,
                  value: data[item].city_name,
                  children: []
                });
              } else {
                that.block.push({
                  id: data[item].city_id,
                  parent_id: data[item].parent_id,
                  value: data[item].city_name,
                  children: []
                });
              }
            }
            for (var index in that.province) {
              for (var index1 in that.city) {
                if (that.province[index].id === that.city[index1].parent_id) {
                  that.province[index].children.push(that.city[index1]);
                }
              }
            }
            for (var item1 in that.city) {
              for (var item2 in that.block) {
                if (that.city[item1].id === that.block[item2].parent_id) {
                  that.city[item1].children.push(that.block[item2]);
                }
              }
            }
          } else {
          }
        })
        .catch(err=>{
          console.error(err)
        });
    },
    // 选省
    choseProvince(e) {
      // this.provinceStap = e
      this.addshi = [];
      for (var index2 in this.province) {
        if (e === this.province[index2].id) {
          this.shi1 = this.province[index2].children;
          this.shi = this.province[index2].children[0].value;
          this.qu1 = this.province[index2].children[0].children;
          this.qu = this.province[index2].children[0].children[0].value;
          this.E = this.qu1[0].idp;
        }
      }
    },
    //选市
    choseshi(t) {
      var obj = {};
      obj.id = t.id;
      obj.value = t.value;
      for (var i in this.addshi) {
        if (this.addshi[i].id == obj.id) {
          return false;
        }
      }
      this.addshi.push(obj);
    },
    //删除市
    unsershi(f) {
      var w = confirm("确定删除吗？");
      if (w) {
        this.addshi.splice(f, 1);
      } else {
        return false;
      }
    },
    quedingcurrcity() {
      var regionidsmap = "";
      var regionnames = "";
      for (var item in this.addshi) {
        regionidsmap = regionidsmap + this.addshi[item].id + ",";
        regionnames = regionnames + this.addshi[item].value + "-";
      }
      regionidsmap = regionidsmap.substr(0, regionidsmap.length - 1);
      regionnames = regionnames.substr(0, regionnames.length - 1);
      this.obj[this.current_city_index].city_id = regionidsmap;
      this.obj[this.current_city_index].city_name = regionnames;
      this.xuanzechengshi = !this.xuanzechengshi;
    },
    resetData() {
      //重置数据
      (this.status = false),
        (this.formData = [
          {
            start_num: "",
            start_money: "",
            plus_num: "",
            plus_money: "",
            // status: false,
            default: "1",
            city_id: "",
            city_name: ""
          }
        ]);
      this.xuanzechengshi = false;
      //    provinceStap:"",
      this.addshi = [
        {
          id: "52",
          value: "北京"
        }
      ];
      (this.current_city_index = ""),
        (this.formDatas = [
          {
            start_num: "",
            start_money: "",
            plus_num: "",
            plus_money: "",
            default: 0
          }
        ]);
      this.obj = [
        {
          city_id: "52",
          city_name: "北京",
          start_num: "",
          start_money: "",
          plus_num: "",
          plus_money: ""
          // default: "1",
          // status: true
        }
      ];
      this.province = "";
      this.shi1 = "";
      this.datas = {};
      this.name = "";
    }
  },
  created() {
    // this.getCityMessage();
  }
};
</script>
<style scoped>
/* @import "../../static/bootstrap/css/bootstrap.min.css"; */
.padd_left {
  padding-left: 36px;
  padding-left: 36px;
}
.chongqi {
  display: flex;
  align-items: center;
  line-height: 80px;
}
.chongqi span {
  font-size: 14px;
  color: #333;
}
/* .chongqi input {
  width: 300px;
  height: 40px;
  border-radius: 4px;
  border: 1px solid #e6e6e6;
  outline: none;
  margin-left: 20px;
  text-indent: 1em;
} */
.muban_name {
  width: 300px;
  margin: 0 10px;
}
.small-input {
  width: 100px;
  margin: 0 10px;
}
.xiaozi input {
  width: 80px;
  margin-right: 10px;
}
.chongqi .zhichi_input {
  width: 20px;
  height: 20px;
  display: inline-block;
}
.chongqi .tishi {
  padding-left: 15px;
  font-size: 12px;
  color: #333;
}
.tit_top {
  line-height: 50px;
  padding-left: 30px;
  border-bottom: 1px solid #e6e6e6;
  background: #f5f5f5;
}
.tit_top span:first-child {
  font-size: 16px;
  color: #ff6b56;
  font-weight: 600;
}
.tit_top span:last-child {
  font-size: 16px;
  color: #333;
  padding-left: 27px;
}
.shezhi {
  width: 200px;
  height: 40px;
  border: 1px solid #ff6b56;
  border-radius: 4px;
  text-align: center;
  line-height: 40px;
  color: #ff6b56;
}
.search_box {
  display: flex;
  align-items: center;
  padding: 10px;
  border-top: 1px solid #e6e6e6;
  border-bottom: 1px solid #e6e6e6;
}
.search_box .inputs {
  width: 100px;
  height: 40px;
}
.btn-group {
  margin: 0 10px;
}
.btn-group button {
  height: 40px;
}
.lahei {
  background: #fff;
  border: none;
  outline: none;
  color: #ff6b56;
}
thead th {
  text-align: center;
}
tr td {
  text-align: center;
}
tr td p {
  margin-top: 5px;
  color: #333;
}
tr td:last-child span {
  display: inline-block;
  margin-left: 10px;
}
tr td:last-child a {
  color: #ff6b56;
}
tr td input {
  width: 90px;
  height: 40px;
  margin-bottom: 20px;
  margin-top: 15px;
  border-radius: 4px;
  outline: none;
  text-align: center;
  border: 0;
  border: 1px solid #e6e6e6;
}
tr td button {
  width: 90px;
  height: 40px;
  margin-top: 10px;
  outline: none;
  border-radius: 4px;
  border: 0;
  border: 1px solid #e6e6e6;
}
.glyphicons {
  margin-top: 20px;
}
.tiajia_btn {
  width: 60px;
  margin-right: 30px;
  color: #fff;
  background: linear-gradient(to right, #fd314a, #ffd778);
}
.quanxuan_tr td:nth-child(2) {
  text-align: left;
}
.quanxuan_tr td span {
  margin: 0 20px;
}
/* 页码 */
.pagination > li {
  display: inline-block;
  margin: 5px;
}
.sub_btn {
  text-align: right;
}
.sub_btn button {
  width: 120px;
  height: 40px;
  border-radius: 4px;
  margin-right: 30px;
}
.sub_btn button:first-child {
  border: 0;
  color: #fff;
  background: linear-gradient(to right, #fd314a, #ffd778);
}
.sub_btn button:last-child {
  color: #ff6b56;
  border: 1px solid #e6e6e6;
}
.sub_btn {
  margin-top: 30px;
}
.addres {
  background: #fff;
}
.remove {
  margin-top: 18px;
}
.marginTop10 {
  margin-top: 10px;
}
</style>
<style>
/* .yunfei .el-checkbox__inner{
  margin-top:5px;
} */
</style>



// WEBPACK FOOTER //
// src/components/YunFei.vue